<template>
  <div>
    <div class="d-flex flex-column flex-md-row justify-space-between align-md-center mb-4">
      <h2 class="primary--text mb-3 mb-md-0">Registro de Actividad</h2>
      <div class="d-flex align-center">
        <v-menu
          v-model="menuDate"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateFormatted"
              label="Fecha"
              prepend-inner-icon="mdi-calendar"
              readonly
              outlined
              dense
              hide-details
              v-bind="attrs"
              v-on="on"
              style="max-width: 200px"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="date"
            @input="menuDate = false"
            locale="es"
            no-title
          ></v-date-picker>
        </v-menu>
      </div>
    </div>

    <!-- Filtros -->
    <div class="d-flex flex-column flex-md-row mb-4" style="gap: 12px">
      <v-text-field
        v-model="search"
        placeholder="Buscar por usuario"
        color="primary"
        background-color="#DDDDE4"
        prepend-inner-icon="mdi-magnify"
        outlined
        dense
        hide-details
      ></v-text-field>
      <v-select
        v-model="filterAction"
        :items="actionOptions"
        label="Acción"
        outlined
        dense
        hide-details
        clearable
        style="max-width: 200px"
      ></v-select>
      <v-select
        v-model="filterCollection"
        :items="collectionOptions"
        label="Colección"
        outlined
        dense
        hide-details
        clearable
        style="max-width: 200px"
      ></v-select>
    </div>

    <v-progress-linear v-if="isLoading" indeterminate class="mb-4" />

    <p v-if="!isLoading && logs.length === 0" class="text-center mt-4 grey--text">
      No hay registros para esta fecha
    </p>

    <!-- Logs -->
    <audit-log-item
      v-for="log in filteredLogs"
      :key="log._id"
      :log="log"
    ></audit-log-item>

    <p v-if="!isLoading && logs.length > 0 && filteredLogs.length === 0" class="text-center mt-4 grey--text">
      No hay resultados con los filtros aplicados
    </p>
  </div>
</template>

<script>
import AuditLog from "../../domain/AuditLog";

export default {
  name: "AuditLogsTable",
  components: {
    AuditLogItem: () => import("./AuditLogItem.vue"),
  },
  data() {
    const today = new Date();
    const dateStr = today.toISOString().substr(0, 10);
    return {
      logs: [],
      isLoading: false,
      date: dateStr,
      menuDate: false,
      search: "",
      filterAction: null,
      filterCollection: null,
    };
  },
  mounted() {
    this.fetchLogs();
  },
  computed: {
    dateFormatted() {
      if (!this.date) return "";
      const [y, m, d] = this.date.split("-");
      return `${d}/${m}/${y}`;
    },
    actionOptions() {
      const actions = [...new Set(this.logs.map((l) => l.action))];
      return actions.sort();
    },
    collectionOptions() {
      const collections = [...new Set(this.logs.map((l) => l.collectionName))];
      return collections.sort().map((c) => ({ text: this.formatCollection(c), value: c }));
    },
    filteredLogs() {
      return this.logs.filter((log) => {
        const matchSearch = !this.search || log.userId.toUpperCase().includes(this.search.toUpperCase());
        const matchAction = !this.filterAction || log.action === this.filterAction;
        const matchCollection = !this.filterCollection || log.collectionName === this.filterCollection;
        return matchSearch && matchAction && matchCollection;
      });
    },
  },
  watch: {
    date() {
      this.fetchLogs();
    },
  },
  methods: {
    async fetchLogs() {
      try {
        this.isLoading = true;
        this.logs = await AuditLog.getByDate(this.date);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.warn(error);
      }
    },
    formatCollection(name) {
      const map = {
        plan_homes: "Pagos Hogar",
        receipts: "Recibos",
        clients: "Clientes",
        temporal_clients: "Clientes Temporales",
        antennas: "Antenas",
        services: "Servicios",
        users: "Usuarios",
      };
      return map[name] || name;
    },
  },
};
</script>
